module.exports = function (app) {

    app.directive('requiresLogin', function () {
		var ENTER_BUTTON = 13;
        return {
            restrict : 'A',
            replace  : false,
            priority : -1000,
            scope    : false,
            controller : ['$scope', 'sessionData', 'modal', function ($scope, sessionData, modal) {

                $scope.isLoggedIn = sessionData.loggedIn;

                $scope.openModal = function (description, title) {
                    modal.open({
                        template: "<article class='favoritesForm'><h1>" + title + "</h1><section><p>" + description + "</p></section></article>"
                    });
                };

                $scope.$watch(function () { return sessionData.loggedIn; }, function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        $scope.isLoggedIn = newVal;
                    }
                });

            }],
            compile : function () {
                return {
                    pre : function () {},
                    post : function (scope, ele) {
                        ele.on('click keypress', function (event) {

                            if(!scope.isLoggedIn) {

                                event.preventDefault();
                                event.stopImmediatePropagation();

                                //If user hits enter or clicks, open modal
                                if (event.which == ENTER_BUTTON || event.type == 'click') {
                                    scope.openModal('You must be logged in to use this feature.', 'Login Required');
                                }
                            }
                        });
                    }
                };
            }
        };
    });

};